import { render, staticRenderFns } from "./gl-form.vue?vue&type=template&id=1f23b98a"
import script from "./gl-form.vue?vue&type=script&lang=js"
export * from "./gl-form.vue?vue&type=script&lang=js"
import style0 from "./gl-form.vue?vue&type=style&index=0&id=1f23b98a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports